import { useTranslation } from 'react-i18next';

import VerifyingLoader from '~/apps/product-plus/components/Loaders/VerifyingLoader';

import styles from './styles/VerifyPayment.module.css';

export const VerifyPayment = () => {
  const { t } = useTranslation(['label']);
  return (
    <div data-testid="verify-payment">
      <div className={`${styles.loaderContainer} plus-tools-modal`}>
        <VerifyingLoader />
      </div>
      <div className={styles.content}>
        <p className={styles.text}>{t('CX_AUTH_VERIFYING_PAYMENT')}</p>
      </div>
    </div>);

};

VerifyPayment.displayName = 'VerifyPayment';